/**
 * Lists the files a turn handed to the student, inside the admin transcript.
 *
 * Generated documents (PDF / Word / PowerPoint) are sent as an empty assistant
 * message plus a `cl.File` element, so the transcript used to render them as an
 * italic "No content" and an admin could not tell a document had been produced.
 *
 * Only metadata is persisted — there is no blob storage — so this deliberately
 * shows what the file was, not a download link.
 */

import { FileText } from 'lucide-react';

export interface FileArtifact {
  name: string;
  mime: string;
  /** Human description of the format, resolved server-side from mime/extension. */
  label: string;
}

interface FileArtifactsViewProps {
  artifacts: FileArtifact[];
}

const FileArtifactsView = ({ artifacts }: FileArtifactsViewProps) => {
  if (artifacts.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {artifacts.map((artifact, index) => (
        <div
          key={`${artifact.name}-${index}`}
          className="flex items-center gap-3 rounded-lg border bg-black/5 p-2 dark:bg-white/5"
        >
          <FileText className="size-5 shrink-0 text-muted-foreground" />
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-medium">
              {artifact.name}
            </span>
            <span className="block truncate text-xs text-muted-foreground">
              {artifact.label}
            </span>
          </span>
        </div>
      ))}
    </div>
  );
};

export { FileArtifactsView };
